export type GetPreviousSaturdayProps = {
  periodType: 'week' | 'month'
  offset: number
}

export function getPreviousSaturday(props?: GetPreviousSaturdayProps): number {
  const date = new Date()
  date.setHours(0, 0, 0, 0)
  if (props?.periodType === 'week') {
    date.setDate(date.getDate() - props.offset * 7)
  } else if (props?.periodType === 'month') {
    date.setMonth(date.getMonth() - props.offset)
  }
  date.setDate(date.getDate() - ((date.getDay() + 1) % 7))
  return date.getTime()
}
